<script>
import axios from "axios";

import moment from "moment";

import { getVariant } from "../helpers/badgeLookupTable";

import TitlePage from "../components/layout/TitlePage.vue";
import ModalFormEditStatusVistoBueno from "../components/modals/ModalFormEditStatusVistoBueno.vue";

import { mapGetters, mapActions } from "vuex";

export default {
  components: { TitlePage, ModalFormEditStatusVistoBueno },
  computed: {
    ...mapGetters({
      filtro: "filtros/filtro",
    }),
  },
  data() {
    return {
      fields: [
        { key: "codigo_despacho", label: "N° de despacho" },
        { key: "cliente", label: "Cliente" },
        { key: "institucion", label: "Institucion" },
        { key: "numero_solicitud", label: "N° Solicitud" },
        { key: "fecha_recepcion", label: "F. de ingreso" },
        { key: "numero_documento", label: "N° de documento" },
        { key: "fecha_aprobacion", label: "Fecha de aprobación" },
        { key: "estado", label: "Estado VB" },
        { key: "acciones", label: "Acciones" },
      ],
      vistosBuenos: [{}],

      filter: undefined,

      pageMeta: { current_page: 1 },

      fetchIsPending: undefined,
      fetchIsSuccess: undefined,

      selected: { id: undefined, base: { estado: undefined } },
      statusModal: false,
    };
  },
  methods: {
    ...mapActions({
      cambiarFiltro: "filtros/cambiarFiltro",
    }),
    async fetch() {
      this.fetchIsPending = true;
      try {
        let query = {
          params: {
            page: this.pageMeta?.current_page || 1,
            estado: this.filter?.estado,
            //tipo_inspeccion_id: this.filter?.tipo_inspeccion_id,
          },
        };

        if (this.$route.query.dashboardFilter) {
          query = {
            params: {
              page: this.pageMeta?.current_page || 1,
              estado: `["${this.filtro.value}"]`,
              //tipo_inspeccion_id: this.filter?.tipo_inspeccion_id,
            },
          };
        }

        const { data, status } = await axios.get(
          "/api/admin/vistos-buenos",
          query
        );

        if (status == "200" && data?.data && data?.meta) {
          this.vistosBuenos = [...data.data];
          this.pageMeta = { ...data.meta };
          this.fetchIsSuccess = true;
        } else {
          console.error("Problem feching 'vistos-buenos'");
        }
      } catch (e) {
        console.error("Problem feching 'vistos-buenos':", e);
      }
      this.fetchIsPending = false;
    },
    async updateStatus() {
      const query = {
        estado: this.selected.status,
      };

      try {
        const { status } = await axios.post(
          `/api/admin/documentos/${this.selected.documentId}/validar-vb`,
          query
        );

        if (status == "200") {
          await this.fetch();
        }
      } catch (e) {
        console.error("There was a problem updating a document status:", e);
      }
      this.statusModal = false;
    },
    getVariant(status) {
      return getVariant(status);
    },
  },
  watch: {
    "pageMeta.current_page": function () {
      this.fetch();
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>

<template>
  <div class="flex flex-col gap-8">
    <title-page title="Vistos Buenos" />

    <div class="flex flex-col gap-4 bg-white shadow-md p-4">
      <div class="flex flex-row items-center justify-between gap-2">
        <h1 class="!text-xl !font-bold">Vistos Buenos</h1>
      </div>

      <div
        v-if="fetchIsPending"
        class="text-center mx-auto my-auto h-full text-[#ffce1e]"
      >
        <b-spinner class="align-middle"></b-spinner>
        <strong> Cargando...</strong>
      </div>

      <div v-else>
        <b-table
          class="text-left"
          hover
          show-empty
          responsive
          :items="vistosBuenos"
          :fields="fields"
        >
          <template #empty>
            <h4 class="text-center">No hay elementos en la lista</h4>
          </template>

          <template #cell(codigo_despacho)="row">
            <div class="flex flex-row text-sm items-center gap-2">
              <div
                class="h-6 w-[5px]"
                :class="[getVariant(row.item.estado)]"
              ></div>
              {{ row.item?.despacho?.codigo ?? "-" }}
            </div>
          </template>
          <template #cell(cliente)="row">
            {{ row.item?.cliente?.nombre ?? "-" }}
          </template>
          <template #cell(institucion)="row">
            {{ row.item?.institucion ?? "-" }}
          </template>

          <template #cell(numero_solicitud)="row">
            {{ row.item?.numero_solicitud ?? "-" }}
          </template>

          <template #cell(fecha_recepcion)="row">
            <div class="text-nowrap">
              {{
                row.item?.fecha_recepcion
                  ? moment(row.item?.fecha_recepcion).format("DD-MM-YYYY")
                  : "-"
              }}
            </div>
          </template>
          <template #cell(numero_documento)="row">
            {{ row.item?.numero_documento ?? "-" }}
          </template>
          <template #cell(fecha_aprobacion)="row">
            <div class="text-nowrap">
              {{
                row.item?.fecha_aprobacion
                  ? moment(row.item.fecha_aprobacion).format("DD-MM-YYYY")
                  : "-"
              }}
            </div>
          </template>
          <template #cell(fecha_eta)="row">
            <div class="text-nowrap">
              {{
                row.item.fecha_eta
                  ? moment(row.item.fecha_eta).format("DD-MM-YYYY")
                  : "-"
              }}
            </div>
          </template>
          <template #cell(documento_cde_id)="row">
            <div class="text-nowrap">
              {{ row.item.documento_cde_id ?? "-" }}
            </div>
          </template>
          <template #cell(estado)="row">
            <div
              @click="
                () => {
                  selected.id = row.item.id;
                  selected.base.estado = row.item.estado;
                  statusModal = true;
                }
              "
              class="text-nowrap hover:brightness-110 transition-all cursor-pointer text-center my-auto text-white px-2 hover:scale-105"
              :class="[getVariant(row.item.estado)]"
              v-if="!!row.item.estado"
            >
              {{ row.item.estado ?? "-" }}
            </div>
          </template>
          <template #cell(acciones)="row">
            <div class="flex flex-col items-center gap-4 justify-center px-2">
              <div class="flex flex-row items-center gap-2">
                <button
                  class="btn-extra-primario"
                  @click="
                    () =>
                      $router.push({
                        name: 'Documento',
                        params: {
                          despachoId: row.item.despacho?.id,
                          documentoId: row.item.id,
                        },
                      })
                  "
                >
                  <fas :icon="['fas', 'eye']"></fas>
                  Ver documento
                </button>
              </div>
            </div>
          </template>
        </b-table>

        <b-pagination
          v-if="pageMeta"
          v-model="pageMeta.current_page"
          style="width: 100px; margin: auto"
          :total-rows="pageMeta?.total"
          :per-page="pageMeta?.per_page"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </div>
    </div>

    <ModalFormEditStatusVistoBueno
      v-if="selected"
      :visible="statusModal"
      :documento="selected"
      @close-modal="() => (statusModal = false)"
      @refetch="() => fetch()"
    />
  </div>
</template>
